export default {
    setUser(state, payload) {
      state.users.user = payload;
    },
    setAuthChecking(state, checking) {
      state.users.authChecking = checking;
    },
  };
  